export default __webpack_public_path__ + "static/media/kyc-selfie-illustration.2e2dbc3f.svg";